import { apiCalculate, apiFlux } from "scripts/api/calculate";
import { state } from "scripts/app";
import { MessageToast } from "scripts/ui/components/toast";

export class StartControls {
    btn: HTMLButtonElement;
        
        constructor(){
            const startBtn = document.getElementById('applyBtn');
            if(!(startBtn instanceof HTMLButtonElement)) {throw new Error("Ошибка! Кнопка сброса маркера не найдена")};
    
            this.btn = startBtn;
            this.addEventListener();
        }

        /**
         * Блокируем кнопку сброса датчика
         */
        public setDisable() {
            this.btn.disabled = true;
        }
        public setEnable() {
            this.btn.disabled = false;
        }
    
        private addEventListener(){
            this.btn.addEventListener('click', () => this.startCalculate());
        }
    
        /**
         * Отправка сектора на расчет
        */
        private async startCalculate() {
            if (!state.detector?.id) {
                MessageToast.showDanger("start", "Для расчёта выберите сектор");
                return;
            }
        
            try{
                // Блокируем кнопку во время расчетов
                this.setDisable();
        
                apiFlux(state.detector.id);
            } catch (error) {
                console.log(error);
                MessageToast.showDanger("start", "Не удалось запустить расчёт");
            } finally {
                // Разблокируем кнопку
                this.setEnable();
            }
        }
}